import { FC, useEffect } from "react";
import { Gizmo, useGizmo } from "flowy-3-core";
import { Popconfirm } from "antd";
import * as S from "./Button.styles";

type ButtonProps = {
  gizmo: Gizmo;
};

const Button: FC<ButtonProps> = ({ gizmo }) => {
  const { config, features, binder } = useGizmo({ gizmo });

  useEffect(() => {
    if (binder) {
      binder.data.subscribe((data: any) => {
        if (data.file && data.filename) {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(data.file);
          downloadLink.download = data.filename;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      });
    }
  }, [binder]);

  const handleButtonClick = async () => {
    const config = binder.getConfig();

    if (binder && config.ops?.button?.operation) {
      await binder.dispatchOperation({
        operation: config.ops.button.operation,
      });
    }
  };

  return (
    <>
      {config.ops?.button?.confirmation?.title ? (
        <Popconfirm
          title={config.ops?.button?.confirmation?.title}
          description={config.ops?.button?.confirmation?.description}
          onConfirm={handleButtonClick}
        >
          <S.Button
            id={`button-${gizmo.getConfig().fid}`}
            loading={features.processing}
            type="primary"
          >
            {features.label}
          </S.Button>
        </Popconfirm>
      ) : (
        <S.Button
          id={`button-${gizmo.getConfig().fid}`}
          //columns={gizmo.getColumns()}
          loading={features.processing}
          onClick={handleButtonClick}
          type="primary"
        >
          {features.label}
        </S.Button>
      )}
    </>
  );
};

export default Button;
